import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/dropzone/styles.css'
import '@mantine/notifications/styles.css'
import './App.css';

import { useEffect } from 'react'
import { MantineProvider } from '@mantine/core'
import requestInterceptor, { resetIdleTime } from './api/requestInterceptor'
import responseInterceptor from './api/responseInterceptor'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { apiCallProtected } from './api/axios'
import Login from './pages/login/Login'
import useAuthStore from './store/authStore'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { theme } from './theme/theme'
import { Notifications } from '@mantine/notifications'
import Routing from './Routing'
import PaymentRecovery from './pages/paymentRecovery/PaymentRecovery';
import MainLayout from './commonComponents/layout/MainLayout';
import Layout from './commonComponents/layout/Layout';
import Profile from './commonComponents/layout/Profile';
import Forms from './pages/forms/forms';
import FormsPage from './pages/forms/formsPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  }
})

function App() {
  const { auth_token, auth } = useAuthStore(state => ({
    auth_token: state?.auth?.access_token,
    auth: state?.auth
  }))

  requestInterceptor()
  responseInterceptor()

  useEffect(() => {
    resetIdleTime();
    return () => {
      apiCallProtected.interceptors.request.eject(requestInterceptor)
      apiCallProtected.interceptors.response.eject(responseInterceptor)
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme} defaultColorScheme='light'>
        <Notifications position='top-right' zIndex={99999} limit={5} />
        <BrowserRouter>
          <Routes>
            {auth_token ? (auth?.emp_role_id?.role_name?.toLowerCase() === 'customer support' ? (
              <Route element={<Layout />}>
                <Route element={<MainLayout />}>
                  <Route path='/*' element={<PaymentRecovery />} replace />
                  <Route path='profile' element={<Profile />} />
                </Route>
              </Route>
            ) : auth?.emp_role_id?.role_name?.toLowerCase() === 'scc' || auth?.emp_role_id?.role_name?.toLowerCase() === 'cc' ? (
              <Route element={<Layout />}>
                <Route element={<MainLayout />}>
                  <Route path="forms" element={<Forms />} />
                  <Route path="forms/:form" element={<FormsPage />} />
                  <Route path="profile" element={<Profile />} />

                  {/* ⭐ Default SCC route */}
                  <Route path="/*" element={<Forms />} replace />
                </Route>
              </Route>
            ) : (
              <Route path='/*' element={<Routing />} />
            )) : (
              <Route path='/*' element={<Login />} />
            )}
          </Routes>
        </BrowserRouter>
      </MantineProvider>
    </QueryClientProvider>
  )
}

export default App
